import {PROPERTIES_FOR_METRIC,
    COST_METRIC_NAME, CLICKS_METRIC_NAME, CONVERSIONS_METRIC_NAME, IMPRESSIONS_METRIC_NAME,
    CPC_METRIC_NAME, CTR_METRIC_NAME, CPM_METRIC_NAME, CPA_METRIC_NAME,
    PURCHASES_VALUE_METRIC_NAME, ROAS_METRIC_NAME, ACOS_METRIC_NAME,
    GA4_SESSIONS_METRIC_NAME, GA4_ACTIVE_USERS_METRIC_NAME, GA4_CONVERSIONS_METRIC_NAME,
    GA4_ECOMMERCE_PURCHASES_METRIC_NAME, GA4_PURCHASE_REVENUE_METRIC_NAME,
    GA4_ROAS_METRIC_NAME, GA4_ACOS_METRIC_NAME, GA4_CPA_METRIC_NAME,
    ECOMMERCE_SESSIONS_METRIC_NAME, ECOMMERCE_GROSS_REVENUE_METRIC_NAME, ECOMMERCE_ORDERS_METRIC_NAME,
    ECOMMERCE_AVG_GROSS_ORDER_VALUE_METRIC_NAME, ECOMMERCE_ROAS_METRIC_NAME, ECOMMERCE_ACOS_METRIC_NAME,
    ECOMMERCE_CONVERTION_RATE_METRIC_NAME, ECOMMERCE_CPA_METRIC_NAME,
    CONVERSION_RATE_METRIC_NAME,
    META_REACH_METRIC_NAME, META_FREQUENCY_METRIC_NAME, META_VIDEO_VIEW_METRIC_NAME,
    META_THRUPLAY_METRIC_NAME, META_COST_PER_THRUPLAY_METRIC_NAME,
    META_VIDEO_VIEW_3S_METRIC_NAME, META_VIDEO_VIEW_3S_RATE_METRIC_NAME,
    META_IG_NEW_FOLLOWERS_METRIC_NAME, META_COST_PER_IG_NEW_FOLLOWER_METRIC_NAME,
    META_IG_PROFILE_VISITS_METRIC_NAME, META_COST_PER_IG_PROFILE_VISIT_METRIC_NAME,
    META_POST_REACTION_METRIC_NAME,
    META_COMMENT_METRIC_NAME, META_CLICK_TO_CALL_METRIC_NAME,
    META_LIKE_METRIC_NAME, META_COST_PER_LIKE_METRIC_NAME,
    META_PIXEL_PURCHASE_METRIC_NAME, META_COST_PER_PIXEL_PURCHASE_METRIC_NAME,
    META_PIXEL_LEAD_METRIC_NAME, META_COST_PER_PIXEL_LEAD_METRIC_NAME,
    META_MESSAGING_CONVERSATION_STARTED_7D_METRIC_NAME, META_COST_PER_MESSAGING_CONVERSATION_STARTED_7D_METRIC_NAME,
    META_LEAD_METRIC_NAME, META_COST_PER_LEAD_METRIC_NAME,
    META_ONSITE_LEAD_METRIC_NAME, META_COST_PER_ONSITE_LEAD_METRIC_NAME,
    GOOGLE_SEARCH_IS_METRIC_NAME, GOOGLE_SEARCH_TOP_IS_METRIC_NAME, GOOGLE_SEARCH_ABS_TOP_IS_METRIC_NAME,
    GOOGLE_SEARCH_LOST_IS_RANK_METRIC_NAME, GOOGLE_SEARCH_LOST_IS_BUDGET_METRIC_NAME,
    GOOGLE_VIDEO_QUARTILE_P25_RATE_METRIC_NAME, GOOGLE_VIDEO_VIEWS_METRIC_NAME, GOOGLE_CPV_METRIC_NAME,
    GOOGLE_INTERACTIONS_METRIC_NAME,
    TIKTOK_REACH_METRIC_NAME, TIKTOK_FREQUENCY_METRIC_NAME, TIKTOK_VIDEO_VIEWS_METRIC_NAME,
    TIKTOK_VIDEO_VIEW_2S_METRIC_NAME, TIKTOK_VIDEO_VIEW_2S_RATE_METRIC_NAME,
    TIKTOK_FOLLOWS_METRIC_NAME, TIKTOK_COST_PER_FOLLOW_METRIC_NAME,
    TIKTOK_PROFILE_VISITS_METRIC_NAME, TIKTOK_COST_PER_PROFILE_VISIT_METRIC_NAME,
    TIKTOK_LIKES_METRIC_NAME, TIKTOK_COMMENTS_METRIC_NAME,
    TIKTOK_VIDEO_VIEW_6S_METRIC_NAME, TIKTOK_VIDEO_VIEW_6S_RATE_METRIC_NAME,
    LINKEDIN_VIDEO_VIEWS_METRIC_NAME, LINKEDIN_VIDEO_COMPLETIONS_METRIC_NAME,
    LINKEDIN_TOTAL_ENGAGEMENTS_METRIC_NAME, LINKEDIN_REACTIONS_METRIC_NAME,
    LINKEDIN_COMMENTS_METRIC_NAME, LINKEDIN_SHARES_METRIC_NAME, LINKEDIN_FOLLOWS_METRIC_NAME,
    LINKEDIN_LEAD_FORM_LEADS_METRIC_NAME, LINKEDIN_LEAD_FORM_OPENS_METRIC_NAME,
} from "./metrics";
import i18n from "../../i18n";

export const TODAY_CLICKS_COLUMN = 'TODAY_CLICKS_COLUMN';
export const TODAY_IMPRESSIONS_COLUMN = 'TODAY_IMPRESSIONS_COLUMN';
export const TODAY_COST_COLUMN = 'TODAY_COST_COLUMN';
export const TODAY_CONVERSIONS_COLUMN = 'TODAY_CONVERSIONS_COLUMN';
export const TODAY_CPC_COLUMN = 'TODAY_CPC_COLUMN';
export const TODAY_CPA_COLUMN = 'TODAY_CPA_COLUMN';
export const TODAY_CTR_COLUMN = 'TODAY_CTR_COLUMN';
export const TODAY_CPM_COLUMN = 'TODAY_CPM_COLUMN';

export const CURRENT_PERIOD_CPA_COLUMN = 'CURRENT_PERIOD_CPA_COLUMN';
export const CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA_COLUMN = 'CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA_COLUMN';
export const CURRENT_PERIOD_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN = 'CURRENT_PERIOD_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN';
export const CURRENT_PERIOD_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN = 'CURRENT_PERIOD_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN';
export const YESTERDAY_CPA_VS_LAST_PERIOD_COLUMN = 'YESTERDAY_CPA_VS_LAST_PERIOD_COLUMN';
export const YESTERDAY_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN = 'YESTERDAY_CPA_VS_THREE_PERIODS_AGO_CPA_COLUMN';
export const YESTERDAY_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN = 'YESTERDAY_CPA_VS_SIX_PERIODS_AGO_CPA_COLUMN';

export const FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN = 'FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN';
export const FULL_PERIOD_COST_VS_PROJECTED_COLUMN = 'FULL_PERIOD_COST_VS_PROJECTED_COLUMN';
export const FULL_PERIOD_ODS_COLUMN = 'FULL_PERIOD_ODS_COLUMN';
export const YESTERDAY_EXPENSES_COLUMN = 'YESTERDAY_EXPENSES_COLUMN';
export const LAST_7_DAYS_AVERAGE_EXPENSES_COLUMN = 'LAST_7_DAYS_AVERAGE_EXPENSES_COLUMN';
export const FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN = 'FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN';
export const FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN = 'FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN';
export const FULL_PERIOD_ODS_VS_PLATFORM_BUDGET_COLUMN = 'FULL_PERIOD_ODS_VS_PLATFORM_BUDGET_COLUMN';
export const FULL_PERIOD_CONVERSIONS_COLUMN = 'FULL_PERIOD_CONVERSIONS_COLUMN';
export const PURCHASES_VALUE_COLUMN = 'PURCHASES_VALUE_COLUMN';
export const LAST_PERIOD_PURCHASES_VALUE_COLUMN = 'LAST_PERIOD_PURCHASES_VALUE_COLUMN';
export const ROAS_COLUMN = 'ROAS_COLUMN';
export const ACOS_COLUMN = 'ACOS_COLUMN';
export const FULL_PERIOD_ROAS_VS_LAST_MONTH_COLUMN = 'FULL_PERIOD_ROAS_VS_LAST_MONTH_COLUMN';
export const FULL_PERIOD_ACOS_VS_LAST_MONTH_COLUMN = 'FULL_PERIOD_ACOS_VS_LAST_MONTH_COLUMN';

export const CURRENT_PERIOD_ALLOCATED_BUDGET_COLUMN = 'CURRENT_PERIOD_ALLOCATED_BUDGET_COLUMN';
export const CURRENT_PERIOD_PERIOD_DATES_COLUMN = 'CURRENT_PERIOD_PERIOD_DATES_COLUMN';
export const CURRENT_PERIOD_ROLLOVER_BALANCE_COLUMN = 'CURRENT_PERIOD_ROLLOVER_BALANCE_COLUMN';
export const CURRENT_PERIOD_TOTAL_BUDGET_COLUMN = 'CURRENT_PERIOD_TOTAL_BUDGET_COLUMN';
export const CURRENT_PERIOD_COST_COLUMN = 'CURRENT_PERIOD_COST_COLUMN';

export const LAST_PERIOD_ALLOCATED_BUDGET_COLUMN = 'LAST_PERIOD_ALLOCATED_BUDGET_COLUMN';
export const LAST_PERIOD_ROLLOVER_BALANCE_COLUMN = 'LAST_PERIOD_ROLLOVER_BALANCE_COLUMN';
export const LAST_PERIOD_TOTAL_BUDGET_COLUMN = 'LAST_PERIOD_TOTAL_BUDGET_COLUMN';
export const LAST_PERIOD_COST_COLUMN = 'LAST_PERIOD_COST_COLUMN';

export const BUSINESS_UNIT_COLUMN = 'BUSINESS_UNIT_COLUMN';

export const AGENCY_FLEX_INDICATOR = 'FLEX_INDICATOR';
export const URL_INDICATOR = "URL_INDICATOR"

export const LABELS_COLUMN = 'LABELS_COLUMN';
export const CURRENCY_COLUMN = 'CURRENCY_COLUMN';

export const GOAL_1_COLUMN = "GOAL_1_COLUMN"
export const GOAL_1_INFO_COLUMN = "GOAL_1_INFO_COLUMN"
export const GOAL_2_COLUMN = "GOAL_2_COLUMN"
export const GOAL_2_INFO_COLUMN = "GOAL_2_INFO_COLUMN"

export const AVAILABLE_FUNDS_COLUMN = 'AVAILABLE_FUNDS_COLUMN';
export const DAYS_TILL_FUNDS_ARE_OUT_COLUMN = 'DAYS_TILL_FUNDS_ARE_OUT_COLUMN';
export const AVAILABLE_FUNDS_LAST_UPLOAD_ON_COLUMN = 'AVAILABLE_FUNDS_LAST_UPLOAD_ON_COLUMN';

export const COMMENTS_COLUMN = 'COMMENTS_COLUMN'

export const PLATFORM_BUDGET_COLUMN = 'PLATFORM_BUDGET_COLUMN';
export const CAMPAIGN_STATUS_COLUMN = 'CAMPAIGN_STATUS_COLUMN';

// Columnas que quedan vacías en filas BU/BUCC (solo aplican a Campaign/Adgroup).
export const EMPTY_FOR_BU_AND_BUCC_COLUMNS = [CAMPAIGN_STATUS_COLUMN];

export const CURRENT_PERIOD_TIME_COMPLETION_COLUMN = 'CURRENT_PERIOD_TIME_COMPLETION_COLUMN';
export const CURRENT_PERIOD_AMOUNT_COMPLETION_COLUMN = 'CURRENT_PERIOD_AMOUNT_COMPLETION_COLUMN';
export const CURRENT_PERIOD_COST_VS_TIME_COLUMN = 'CURRENT_PERIOD_COST_VS_TIME_COLUMN';

export const CURRENT_PERIOD_BUDGET_DATA = [CURRENT_PERIOD_ALLOCATED_BUDGET_COLUMN, CURRENT_PERIOD_ROLLOVER_BALANCE_COLUMN, CURRENT_PERIOD_TOTAL_BUDGET_COLUMN, CURRENT_PERIOD_COST_COLUMN, CURRENT_PERIOD_AMOUNT_COMPLETION_COLUMN, CURRENT_PERIOD_COST_VS_TIME_COLUMN];

export const ONLY_FOR_BU_NOT_BUCC_COLUMN = [CURRENT_PERIOD_AMOUNT_COMPLETION_COLUMN, CURRENT_PERIOD_COST_VS_TIME_COLUMN, CURRENT_PERIOD_TIME_COMPLETION_COLUMN, LABELS_COLUMN, CURRENCY_COLUMN, CURRENT_PERIOD_TOTAL_BUDGET_COLUMN, FULL_PERIOD_ODS_COLUMN, FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN, FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN, FULL_PERIOD_ODS_VS_PLATFORM_BUDGET_COLUMN, CURRENT_PERIOD_ROLLOVER_BALANCE_COLUMN, LAST_PERIOD_ALLOCATED_BUDGET_COLUMN, LAST_PERIOD_ROLLOVER_BALANCE_COLUMN, LAST_PERIOD_TOTAL_BUDGET_COLUMN, AVAILABLE_FUNDS_COLUMN, DAYS_TILL_FUNDS_ARE_OUT_COLUMN, AVAILABLE_FUNDS_LAST_UPLOAD_ON_COLUMN, GOAL_1_COLUMN, GOAL_2_COLUMN, GOAL_1_INFO_COLUMN, GOAL_2_INFO_COLUMN, COMMENTS_COLUMN]

export const CAMPAIGN_AND_ADGROUP_ROW_EXCLUDED_COLUMNS = [LABELS_COLUMN, CURRENCY_COLUMN, AVAILABLE_FUNDS_COLUMN, DAYS_TILL_FUNDS_ARE_OUT_COLUMN, AVAILABLE_FUNDS_LAST_UPLOAD_ON_COLUMN]

export const LAST_PERIOD_BUDGET_DATA = [LAST_PERIOD_ALLOCATED_BUDGET_COLUMN, LAST_PERIOD_ROLLOVER_BALANCE_COLUMN, LAST_PERIOD_TOTAL_BUDGET_COLUMN, LAST_PERIOD_COST_COLUMN];

export const CURRENT_PERIOD_CPA_VS_COLUMNS = [CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA_COLUMN, CURRENT_PERIOD_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN, CURRENT_PERIOD_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN,];

export const YESTERDAY_CPA_VS_COLUMNS = [YESTERDAY_CPA_VS_LAST_PERIOD_COLUMN, YESTERDAY_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN, YESTERDAY_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN];

export const FULL_PERIOD_CPA_COLUMNS = [CURRENT_PERIOD_CPA_COLUMN].concat(CURRENT_PERIOD_CPA_VS_COLUMNS.concat(YESTERDAY_CPA_VS_COLUMNS));

export const GOALS_COLUMNS = [GOAL_1_INFO_COLUMN, GOAL_1_COLUMN, GOAL_2_INFO_COLUMN, GOAL_2_COLUMN]

export const AVAILABLE_FUNDS_COLUMNS = [AVAILABLE_FUNDS_COLUMN, LAST_7_DAYS_AVERAGE_EXPENSES_COLUMN, DAYS_TILL_FUNDS_ARE_OUT_COLUMN, AVAILABLE_FUNDS_LAST_UPLOAD_ON_COLUMN]

export const FULL_PERIOD_COLUMNS = [FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN, FULL_PERIOD_COST_VS_PROJECTED_COLUMN, FULL_PERIOD_ODS_COLUMN, YESTERDAY_EXPENSES_COLUMN, FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN, LAST_7_DAYS_AVERAGE_EXPENSES_COLUMN, FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN, FULL_PERIOD_ODS_VS_PLATFORM_BUDGET_COLUMN, FULL_PERIOD_CONVERSIONS_COLUMN, PURCHASES_VALUE_COLUMN, LAST_PERIOD_PURCHASES_VALUE_COLUMN, ROAS_COLUMN, ACOS_COLUMN, FULL_PERIOD_ROAS_VS_LAST_MONTH_COLUMN, FULL_PERIOD_ACOS_VS_LAST_MONTH_COLUMN].concat(FULL_PERIOD_CPA_COLUMNS).concat(GOALS_COLUMNS);

export const TODAY_COLUMNS = [TODAY_CLICKS_COLUMN, TODAY_IMPRESSIONS_COLUMN, TODAY_COST_COLUMN, TODAY_CONVERSIONS_COLUMN, TODAY_CPC_COLUMN, TODAY_CPA_COLUMN, TODAY_CTR_COLUMN, TODAY_CPM_COLUMN];

// sections
export const NAMES_FOR_TODAY_COLUMNS_SECTIONS = [TODAY_CLICKS_COLUMN, TODAY_IMPRESSIONS_COLUMN, TODAY_COST_COLUMN, TODAY_CONVERSIONS_COLUMN, TODAY_CPC_COLUMN, TODAY_CPA_COLUMN, TODAY_CTR_COLUMN, TODAY_CPM_COLUMN];

export const NAMES_FOR_FUNDS_COLUMN_SECTIONS = AVAILABLE_FUNDS_COLUMNS

export const NAMES_FOR_BUDGET_COLUMNS_SECTIONS = [PLATFORM_BUDGET_COLUMN, FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN, FULL_PERIOD_COST_VS_PROJECTED_COLUMN, FULL_PERIOD_ODS_COLUMN, YESTERDAY_EXPENSES_COLUMN, FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN, LAST_7_DAYS_AVERAGE_EXPENSES_COLUMN, FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN, FULL_PERIOD_ODS_VS_PLATFORM_BUDGET_COLUMN].concat(CURRENT_PERIOD_BUDGET_DATA).concat(LAST_PERIOD_BUDGET_DATA);

export const NAMES_FOR_CONVERSIONS_COLUMNS_SECTIONS = [FULL_PERIOD_CONVERSIONS_COLUMN, PURCHASES_VALUE_COLUMN, LAST_PERIOD_PURCHASES_VALUE_COLUMN, ROAS_COLUMN, ACOS_COLUMN, FULL_PERIOD_ROAS_VS_LAST_MONTH_COLUMN, FULL_PERIOD_ACOS_VS_LAST_MONTH_COLUMN, CURRENT_PERIOD_CPA_COLUMN, CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA_COLUMN, CURRENT_PERIOD_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN, CURRENT_PERIOD_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN, YESTERDAY_CPA_VS_LAST_PERIOD_COLUMN, YESTERDAY_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN, YESTERDAY_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN];

export const COLUMN_HEADER_INFORMATION = {
    [BUSINESS_UNIT_COLUMN]: {
        title: 'Cliente | Línea de seguimiento', subtitle: '', helper: '',
    }, [LABELS_COLUMN]: {
        title: 'Etiquetas',
        subtitle: '',
        helper: "Las etiquetas te ayudan a organizar las líneas de seguimiento en grupos para que puedas filtrar e informar sobre los datos que te interesan.",
    }, [CURRENCY_COLUMN]: {
        title: 'Moneda',
        subtitle: '',
        helper: "El tipo de moneda en la que se calcula y se muestra la línea de seguimiento. Si alguna de sus cuentas publicitarias opera en otra moneda, los importes de esa cuenta se muestran convertidos al tipo de cambio del día.",
    }, [AVAILABLE_FUNDS_COLUMN]: {
        title: 'Saldo',
        subtitle: '',
        helper: "El saldo disponible. Se condidera lo que cargó el usuario y los consumos que se realizan posterior a la carga.",
    }, [DAYS_TILL_FUNDS_ARE_OUT_COLUMN]: {
        title: 'Días con saldo',
        subtitle: '',
        helper: "Se calcula en cuantos días se agotará el saldo vigente. Se considera el gasto promedio de los últimos 7 días para hacer la estimación",
    }, [AVAILABLE_FUNDS_LAST_UPLOAD_ON_COLUMN]: {
        title: 'Edición manual de saldo',
        subtitle: '',
        helper: "Se muestra la última vez que un usuario edito el saldo",
    }, [CURRENT_PERIOD_TIME_COMPLETION_COLUMN]: {
        title: 'Tiempo Transcurrido',
        subtitle: 'Este período',
        helper: "El porcentaje de tiempo transcurrido del período actual",
    }, [CURRENT_PERIOD_AMOUNT_COMPLETION_COLUMN]: {
        title: 'Porcentaje Invertido',
        subtitle: 'Este período',
        helper: "El porcentaje del presupuesto invertido sobre el total",
    }, [TODAY_CLICKS_COLUMN]: {
        title: 'Clicks',
        subtitle: 'Hoy',
        helper: "Número de clicks adquiridos desde la última sincronización de hoy. Si la alerta está habilitada, comparará los clics de hoy con los datos estadísticos del pasado.",
    }, [TODAY_IMPRESSIONS_COLUMN]: {
        title: 'Impresiones',
        subtitle: 'Hoy',
        helper: "Número de impresiones adquirido desde la última sincronización de hoy. Si la alerta está habilitada, comparará las impresiones de hoy con datos estadísticos del pasado.",
    }, [TODAY_COST_COLUMN]: {
        title: 'Costo',
        subtitle: 'Hoy',
        helper: "Costo incurrido desde la última sincronización de hoy. Si la alerta está habilitada, comparará el costo de hoy con los datos estadísticos del pasado.",
    }, [TODAY_CONVERSIONS_COLUMN]: {
        title: 'Conversiones',
        subtitle: 'Hoy',
        helper: "Número de conversiones adquiridas en el día de hoy. Si la alerta está habilitada, comparará las conversiones con los datos estadísticos del pasado.",
    }, [TODAY_CPC_COLUMN]: {
        title: 'CPC',
        subtitle: 'Hoy',
        helper: "Costo promedio por click de hoy hasta la última sincronización registrada. Si la alerta está habilitada, comparará el CPC de hoy con los datos estadísticos del pasado.",
    }, [TODAY_CPA_COLUMN]: {
        title: 'CPA',
        subtitle: 'Hoy',
        helper: "Costo por adquisición registrada. Si la alerta está habilitada, comparará el CPA con los datos estadísticos del pasado.",
    }, [TODAY_CTR_COLUMN]: {
        title: 'CTR',
        subtitle: 'Hoy',
        helper: "Tasa de clicks desde la última sincronización de hoy. Si la alerta está habilitada, comparará el CTR de hoy con los datos estadísticos del pasado.",
    }, [TODAY_CPM_COLUMN]: {
        title: 'CPM',
        subtitle: 'Hoy',
        helper: "Costo de las mil impresiones desde la última sincronización de hoy. Si la alerta está habilitada, comparará el CPM de hoy con los datos estadísticos del pasado.",
    }, [FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN]: {
        title: '*Desvío vs presupuesto total',
        subtitle: 'Este período',
        helper: "Cuánto te desviaste de la inversión esperada a hoy, medido sobre el presupuesto total del período. ↑ por encima, ↓ por debajo.",
    }, [FULL_PERIOD_COST_VS_PROJECTED_COLUMN]: {
        title: '*Desvío vs inversión esperada',
        subtitle: 'Este período',
        helper: "Cuánto te desviaste de la inversión esperada a hoy. Más sensible al inicio del mes.",
    }, [FULL_PERIOD_ODS_COLUMN]: {
        title: 'Costo diario ideal',
        subtitle: 'Este período',
        helper: "Costo diario que debe gastarse desde ahora hasta el final del período para gastar exactamente el presupuesto total. Toma en cuenta los días configurados en las que las campañas funcionan.",
    }, [YESTERDAY_EXPENSES_COLUMN]: {
        title: 'Costo', subtitle: 'Ayer', helper: "Costo de ayer.",
    }, [FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN]: {
        title: 'Costo ideal vs. Costo de ayer',
        subtitle: 'Este período',
        helper: "Comparación entre lo que es el costo diario ideal para el resto del período y la inversión de ayer.",
    }, [LAST_7_DAYS_AVERAGE_EXPENSES_COLUMN]: {
        title: 'Costo',
        subtitle: 'Promedio últimos 7 días',
        helper: "Promedio del costo de los últimos 7 dias sin considerar el día actual",
    }, [FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN]: {
        title: 'Costo ideal vs. Prom. Últ. 7 días',
        subtitle: 'Este período',
        helper: "Comparación entre lo que es el costo diario ideal para el resto del período y la inversión promedio de los últimos 7 días sin considerar el día actual",
    }, [FULL_PERIOD_ODS_VS_PLATFORM_BUDGET_COLUMN]: {
        title: 'Costo ideal vs. Presupuesto en plataforma',
        subtitle: 'Este período',
        helper: "Comparación entre el costo diario ideal para el resto del período y el presupuesto que está configurado hoy en Google Ads, Meta, TikTok o LinkedIn, sumando sólo las campañas en marcha.",
    }, [FULL_PERIOD_CONVERSIONS_COLUMN]: {
        title: 'Conversiones',
        subtitle: 'Este período',
        helper: "Muestra la cantidad de conversiones adquiridas durante el período comparándolo con el proporsional del período anterior. Si pasas el mouse por arriba del día actual mostrará el detalle de conversiones.",
    }, [CURRENT_PERIOD_CPA_COLUMN]: {
        title: 'CPA',
        subtitle: 'Este período',
        helper: "Costo por conversión para el período actual hasta la última hora de sincronización.",
    }, [CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA_COLUMN]: {
        title: 'CPA del mes anterior',
        subtitle: 'Este mes',
        helper: "CPA del mes anterior y su comparación con el CPA de este mes.",
    }, [CURRENT_PERIOD_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN]: {
        title: 'CPA últimos 3 meses',
        subtitle: 'comparado con mes actual',
        helper: "CPA de últimos 3 meses y su comparación con el CPA de este mes.",
    }, [CURRENT_PERIOD_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN]: {
        title: 'CPA últimos 6 meses',
        subtitle: 'comparado con mes actual',
        helper: "CPA de últimos 6 meses y su comparación con el CPA de ayer.",
    }, [YESTERDAY_CPA_VS_LAST_PERIOD_COLUMN]: {
        title: 'CPA del mes anterior',
        subtitle: 'comparado con ayer',
        helper: "CPA del mes anterior y su comparación con el CPA de ayer.",
    }, [YESTERDAY_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN]: {
        title: 'CPA últimos 3 meses',
        subtitle: 'comparado con ayer',
        helper: "Last 3 months CPA and its comparison with yesterday CPA.",
    }, [YESTERDAY_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN]: {
        title: 'CPA últimos 6 meses',
        subtitle: 'Ayer',
        helper: "CPA de últimos 6 meses y su comparación con el CPA de este mes.",
    }, [CURRENT_PERIOD_ALLOCATED_BUDGET_COLUMN]: {
        title: 'Presupuesto', subtitle: 'Este período', helper: "Presupuesto del período configurado.",
    }, [CURRENT_PERIOD_PERIOD_DATES_COLUMN]: {
        title: 'Período', subtitle: 'Fechas del período', helper: "Muestra las fechas y excepciones del período actual.",
    }, [CURRENT_PERIOD_TOTAL_BUDGET_COLUMN]: {
        title: 'Presupuesto Total',
        subtitle: 'Este período',
        helper: "Presupuesto total del período. Este valor va a ser diferente al presupuesto del período sólo si está activada la opción de la línea de seguimiento para que se considere el monto sobrante o faltante del mes en el mes siguiente.",
    }, [CURRENT_PERIOD_ROLLOVER_BALANCE_COLUMN]: {
        title: 'Dif entre presu e invertido',
        subtitle: 'Del mes pasado',
        helper: "El presupuesto que sobró o faltó invertir en el mes anterior. Este valor se sumará al presupuesto mensual total sólo si la opción de la línea de seguimiento para que se considere el monto sobrante o faltante del mes en el mes siguiente está activada.",
    }, [CURRENT_PERIOD_COST_COLUMN]: {
        title: 'Costo',
        subtitle: 'Este período',
        helper: "Inversión de este período hasta la última hora de sincronización.",
    }, [LAST_PERIOD_ALLOCATED_BUDGET_COLUMN]: {
        title: 'Presupuesto', subtitle: 'Mes anterior', helper: "Presupuesto configurado el mes anterior.",
    }, [LAST_PERIOD_ROLLOVER_BALANCE_COLUMN]: {
        title: 'Dif entre presu e invertido',
        subtitle: 'Del mes anterior al pasado',
        helper: "El presupuesto que sobró o faltó invertir en el mes anterior al anterior. Este valor se sumó al presupuesto mensual total del mes pasado sólo si la opción de la línea de seguimiento para que se considere el monto sobrante o faltante del mes en el mes siguiente estaba activada.",
    }, [LAST_PERIOD_TOTAL_BUDGET_COLUMN]: {
        title: 'Presupuesto Total', subtitle: 'Mes anterior', helper: "...",
    }, [LAST_PERIOD_COST_COLUMN]: {
        title: 'Costo', subtitle: 'Mes anterior', helper: "Inversión en pauta del mes pasado",
    }, [PURCHASES_VALUE_COLUMN]: {
        title: 'Valor de compras',
        subtitle: 'Este período',
        helper: "Corresponde al valor de las conversiones y, en el caso de ecommerce, al valor de las compras registradas.",
    }, [LAST_PERIOD_PURCHASES_VALUE_COLUMN]: {
        title: 'Valor de compras',
        subtitle: 'Mes anterior',
        helper: "Corresponde al valor de las conversiones y, en el caso de ecommerce, al valor de las compras registradas en el mes pasado.",
    }, [ROAS_COLUMN]: {
        title: 'ROAS',
        subtitle: 'Este período',
        helper: "Corresponde al ROAS calculado de la siguiente forma: [Valor de Conversiones ¬ Compras] / [Inversión en pauta]",
    }, [ACOS_COLUMN]: {
        title: 'ACOS',
        subtitle: 'Este período',
        helper: "Corresponde al ACOS calculado de la siguiente forma: [Inversión en pauta] / [Valor de Conversiones ¬ Compras]",
    }, [FULL_PERIOD_ROAS_VS_LAST_MONTH_COLUMN]: {
        title: 'ROAS del mes anterior',
        subtitle: 'Este mes',
        helper: "Compara el ROAS de este mes con el ROAS del mes anterior.",
    }, [FULL_PERIOD_ACOS_VS_LAST_MONTH_COLUMN]: {
        title: 'ACOS del mes anterior',
        subtitle: 'Este mes',
        helper: "Compara el ACOS de este mes con el ACOS del mes anterior.",
    },
    [GOAL_1_COLUMN]: {
        title: 'Objetivo 1°',
        subtitle: 'Rendimiento en período',
        helper: "La métrica y el valor objetivo se configuran en la línea de seguimiento",
        priority: 1
    },
    [GOAL_2_COLUMN]: {
        title: 'Objetivo 2°',
        subtitle: 'Rendimiento en período',
        helper: "La métrica y el valor objetivo se configuran en la línea de seguimiento",
        priority: 2
    },
    [GOAL_1_INFO_COLUMN]: {
        title: 'Objetivo 1°',
        subtitle: 'Configuración',
        helper: "Puedes configurar el objetivo que deseas. Sólo debes elegir la métrica y el valor que quieres lograr (ej. CPA = $130).",
        priority: 1
    },
    [GOAL_2_INFO_COLUMN]: {
        title: 'Objetivo 2°',
        subtitle: 'Configuración',
        helper: "Puedes configurar el objetivo que deseas. Sólo debes elegir la métrica y el valor que quieres lograr (ej. CPA = $130).",
        priority: 2
    },
    [COMMENTS_COLUMN]: {
        title: 'Comentarios',
        subtitle: '',
        helper: "Permite guardar un comentario"
    }, [CURRENT_PERIOD_COST_VS_TIME_COLUMN]: {
        title: '% Invertido vs. Tiempo',
        subtitle: 'Este período',
        helper: "Diferencia entre el porcentaje del monto invertido y el porcentaje del tiempo transcurrido del período.",
    }, [PLATFORM_BUDGET_COLUMN]: {
        title: 'Presupuesto en plataforma',
        subtitle: 'Equivalente diario',
        helper: "Presupuesto configurado directamente en Google Ads, Meta, TikTok o LinkedIn, normalizado a equivalente diario.",
    }, [CAMPAIGN_STATUS_COLUMN]: {
        title: 'Estado de Campaña/Adgroup',
        subtitle: '',
        helper: "Estado de la campaña o grupo de anuncios en la plataforma publicitaria (Activa, Pausada, Archivada, Eliminada).",
    }
};

export const getColumnHeaderInformation = (t) => ({
    [BUSINESS_UNIT_COLUMN]: {
        title: t('columns.business_unit.title'), subtitle: '', helper: '',
    }, [LABELS_COLUMN]: {
        title: t('columns.labels.title'),
        subtitle: '',
        helper: t('columns.labels.helper'),
    }, [CURRENCY_COLUMN]: {
        title: t('columns.currency.title'),
        subtitle: '',
        helper: t('columns.currency.helper'),
    }, [AVAILABLE_FUNDS_COLUMN]: {
        title: t('columns.available_funds.title'),
        subtitle: '',
        helper: t('columns.available_funds.helper'),
    }, [DAYS_TILL_FUNDS_ARE_OUT_COLUMN]: {
        title: t('columns.days_till_funds_are_out.title'),
        subtitle: '',
        helper: t('columns.days_till_funds_are_out.helper'),
    }, [AVAILABLE_FUNDS_LAST_UPLOAD_ON_COLUMN]: {
        title: t('columns.available_funds_last_upload_on.title'),
        subtitle: '',
        helper: t('columns.available_funds_last_upload_on.helper'),
    }, [CURRENT_PERIOD_TIME_COMPLETION_COLUMN]: {
        title: t('columns.current_period_time_completion.title'),
        subtitle: t('columns.current_period_time_completion.subtitle'),
        helper: t('columns.current_period_time_completion.helper'),
    }, [CURRENT_PERIOD_AMOUNT_COMPLETION_COLUMN]: {
        title: t('columns.current_period_amount_completion.title'),
        subtitle: t('columns.current_period_amount_completion.subtitle'),
        helper: t('columns.current_period_amount_completion.helper'),
    }, [TODAY_CLICKS_COLUMN]: {
        title: t('columns.today_clicks.title'),
        subtitle: t('columns.today_clicks.subtitle'),
        helper: t('columns.today_clicks.helper'),
    }, [TODAY_IMPRESSIONS_COLUMN]: {
        title: t('columns.today_impressions.title'),
        subtitle: t('columns.today_impressions.subtitle'),
        helper: t('columns.today_impressions.helper'),
    }, [TODAY_COST_COLUMN]: {
        title: t('columns.today_cost.title'),
        subtitle: t('columns.today_cost.subtitle'),
        helper: t('columns.today_cost.helper'),
    }, [TODAY_CONVERSIONS_COLUMN]: {
        title: t('columns.today_conversions.title'),
        subtitle: t('columns.today_conversions.subtitle'),
        helper: t('columns.today_conversions.helper'),
    }, [TODAY_CPC_COLUMN]: {
        title: t('columns.today_cpc.title'),
        subtitle: t('columns.today_cpc.subtitle'),
        helper: t('columns.today_cpc.helper'),
    }, [TODAY_CPA_COLUMN]: {
        title: t('columns.today_cpa.title'),
        subtitle: t('columns.today_cpa.subtitle'),
        helper: t('columns.today_cpa.helper'),
    }, [TODAY_CTR_COLUMN]: {
        title: t('columns.today_ctr.title'),
        subtitle: t('columns.today_ctr.subtitle'),
        helper: t('columns.today_ctr.helper'),
    }, [TODAY_CPM_COLUMN]: {
        title: t('columns.today_cpm.title'),
        subtitle: t('columns.today_cpm.subtitle'),
        helper: t('columns.today_cpm.helper'),
    }, [FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN]: {
        title: t('columns.full_period_budget_proportional.title'),
        subtitle: t('columns.full_period_budget_proportional.subtitle'),
        helper: t('columns.full_period_budget_proportional.helper'),
    }, [FULL_PERIOD_COST_VS_PROJECTED_COLUMN]: {
        title: t('columns.full_period_cost_vs_projected.title'),
        subtitle: t('columns.full_period_cost_vs_projected.subtitle'),
        helper: t('columns.full_period_cost_vs_projected.helper'),
    }, [FULL_PERIOD_ODS_COLUMN]: {
        title: t('columns.full_period_ods.title'),
        subtitle: t('columns.full_period_ods.subtitle'),
        helper: t('columns.full_period_ods.helper'),
    }, [YESTERDAY_EXPENSES_COLUMN]: {
        title: t('columns.yesterday_expenses.title'), 
        subtitle: t('columns.yesterday_expenses.subtitle'), 
        helper: t('columns.yesterday_expenses.helper'),
    }, [FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN]: {
        title: t('columns.full_period_ods_vs_yesterday.title'),
        subtitle: t('columns.full_period_ods_vs_yesterday.subtitle'),
        helper: t('columns.full_period_ods_vs_yesterday.helper'),
    }, [LAST_7_DAYS_AVERAGE_EXPENSES_COLUMN]: {
        title: t('columns.last_7_days_average_expenses.title'),
        subtitle: t('columns.last_7_days_average_expenses.subtitle'),
        helper: t('columns.last_7_days_average_expenses.helper'),
    }, [FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN]: {
        title: t('columns.full_period_ods_vs_last_7_days.title'),
        subtitle: t('columns.full_period_ods_vs_last_7_days.subtitle'),
        helper: t('columns.full_period_ods_vs_last_7_days.helper'),
    }, [FULL_PERIOD_ODS_VS_PLATFORM_BUDGET_COLUMN]: {
        title: t('columns.full_period_ods_vs_platform_budget.title'),
        subtitle: t('columns.full_period_ods_vs_platform_budget.subtitle'),
        helper: t('columns.full_period_ods_vs_platform_budget.helper'),
    }, [FULL_PERIOD_CONVERSIONS_COLUMN]: {
        title: t('columns.full_period_conversions.title'),
        subtitle: t('columns.full_period_conversions.subtitle'),
        helper: t('columns.full_period_conversions.helper'),
    }, [CURRENT_PERIOD_CPA_COLUMN]: {
        title: t('columns.current_period_cpa.title'),
        subtitle: t('columns.current_period_cpa.subtitle'),
        helper: t('columns.current_period_cpa.helper'),
    }, [CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA_COLUMN]: {
        title: t('columns.current_period_cpa_vs_last_period_cpa.title'),
        subtitle: t('columns.current_period_cpa_vs_last_period_cpa.subtitle'),
        helper: t('columns.current_period_cpa_vs_last_period_cpa.helper'),
    }, [CURRENT_PERIOD_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN]: {
        title: t('columns.current_period_cpa_vs_last_three_periods_cpa.title'),
        subtitle: t('columns.current_period_cpa_vs_last_three_periods_cpa.subtitle'),
        helper: t('columns.current_period_cpa_vs_last_three_periods_cpa.helper'),
    }, [CURRENT_PERIOD_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN]: {
        title: t('columns.current_period_cpa_vs_last_six_periods_cpa.title'),
        subtitle: t('columns.current_period_cpa_vs_last_six_periods_cpa.subtitle'),
        helper: t('columns.current_period_cpa_vs_last_six_periods_cpa.helper'),
    }, [YESTERDAY_CPA_VS_LAST_PERIOD_COLUMN]: {
        title: t('columns.yesterday_cpa_vs_last_period.title'),
        subtitle: t('columns.yesterday_cpa_vs_last_period.subtitle'),
        helper: t('columns.yesterday_cpa_vs_last_period.helper'),
    }, [YESTERDAY_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN]: {
        title: t('columns.yesterday_cpa_vs_last_three_periods_cpa.title'),
        subtitle: t('columns.yesterday_cpa_vs_last_three_periods_cpa.subtitle'),
        helper: t('columns.yesterday_cpa_vs_last_three_periods_cpa.helper'),
    }, [YESTERDAY_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN]: {
        title: t('columns.yesterday_cpa_vs_last_six_periods_cpa.title'),
        subtitle: t('columns.yesterday_cpa_vs_last_six_periods_cpa.subtitle'),
        helper: t('columns.yesterday_cpa_vs_last_six_periods_cpa.helper'),
    }, [CURRENT_PERIOD_ALLOCATED_BUDGET_COLUMN]: {
        title: t('columns.current_period_allocated_budget.title'), 
        subtitle: t('columns.current_period_allocated_budget.subtitle'), 
        helper: t('columns.current_period_allocated_budget.helper'),
    }, [CURRENT_PERIOD_PERIOD_DATES_COLUMN]: {
        title: t('columns.current_period_period_dates.title'), 
        subtitle: t('columns.current_period_period_dates.subtitle'), 
        helper: t('columns.current_period_period_dates.helper'),
    }, [CURRENT_PERIOD_TOTAL_BUDGET_COLUMN]: {
        title: t('columns.current_period_total_budget.title'),
        subtitle: t('columns.current_period_total_budget.subtitle'),
        helper: t('columns.current_period_total_budget.helper'),
    }, [CURRENT_PERIOD_ROLLOVER_BALANCE_COLUMN]: {
        title: t('columns.current_period_rollover_balance.title'),
        subtitle: t('columns.current_period_rollover_balance.subtitle'),
        helper: t('columns.current_period_rollover_balance.helper'),
    }, [CURRENT_PERIOD_COST_COLUMN]: {
        title: t('columns.current_period_cost.title'),
        subtitle: t('columns.current_period_cost.subtitle'),
        helper: t('columns.current_period_cost.helper'),
    }, [LAST_PERIOD_ALLOCATED_BUDGET_COLUMN]: {
        title: t('columns.last_period_allocated_budget.title'), 
        subtitle: t('columns.last_period_allocated_budget.subtitle'), 
        helper: t('columns.last_period_allocated_budget.helper'),
    }, [LAST_PERIOD_ROLLOVER_BALANCE_COLUMN]: {
        title: t('columns.last_period_rollover_balance.title'),
        subtitle: t('columns.last_period_rollover_balance.subtitle'),
        helper: t('columns.last_period_rollover_balance.helper'),
    }, [LAST_PERIOD_TOTAL_BUDGET_COLUMN]: {
        title: t('columns.last_period_total_budget.title'), 
        subtitle: t('columns.last_period_total_budget.subtitle'), 
        helper: t('columns.last_period_total_budget.helper'),
    }, [LAST_PERIOD_COST_COLUMN]: {
        title: t('columns.last_period_cost.title'), 
        subtitle: t('columns.last_period_cost.subtitle'), 
        helper: t('columns.last_period_cost.helper'),
    }, [PURCHASES_VALUE_COLUMN]: {
        title: t('columns.purchases_value.title'),
        subtitle: t('columns.purchases_value.subtitle'),
        helper: t('columns.purchases_value.helper'),
    }, [LAST_PERIOD_PURCHASES_VALUE_COLUMN]: {
        title: t('columns.last_period_purchases_value.title'),
        subtitle: t('columns.last_period_purchases_value.subtitle'),
        helper: t('columns.last_period_purchases_value.helper'),
    }, [ROAS_COLUMN]: {
        title: t('columns.roas.title'),
        subtitle: t('columns.roas.subtitle'),
        helper: t('columns.roas.helper'),
    }, [ACOS_COLUMN]: {
        title: t('columns.acos.title'),
        subtitle: t('columns.acos.subtitle'),
        helper: t('columns.acos.helper'),
    }, [FULL_PERIOD_ROAS_VS_LAST_MONTH_COLUMN]: {
        title: t('columns.full_period_roas_vs_last_month.title'),
        subtitle: t('columns.full_period_roas_vs_last_month.subtitle'),
        helper: t('columns.full_period_roas_vs_last_month.helper'),
    }, [FULL_PERIOD_ACOS_VS_LAST_MONTH_COLUMN]: {
        title: t('columns.full_period_acos_vs_last_month.title'),
        subtitle: t('columns.full_period_acos_vs_last_month.subtitle'),
        helper: t('columns.full_period_acos_vs_last_month.helper'),
    },
    [GOAL_1_COLUMN]: {
        title: t('columns.goal_1.title'),
        subtitle: t('columns.goal_1.subtitle'),
        helper: t('columns.goal_1.helper'),
        priority: 1
    },
    [GOAL_2_COLUMN]: {
        title: t('columns.goal_2.title'),
        subtitle: t('columns.goal_2.subtitle'),
        helper: t('columns.goal_2.helper'),
        priority: 2
    },
    [GOAL_1_INFO_COLUMN]: {
        title: t('columns.goal_1_info.title'),
        subtitle: t('columns.goal_1_info.subtitle'),
        helper: t('columns.goal_1_info.helper'),
        priority: 1
    },
    [GOAL_2_INFO_COLUMN]: {
        title: t('columns.goal_2_info.title'),
        subtitle: t('columns.goal_2_info.subtitle'),
        helper: t('columns.goal_2_info.helper'),
        priority: 2
    },
    [COMMENTS_COLUMN]: {
        title: t('columns.comments.title'),
        subtitle: '',
        helper: t('columns.comments.helper')
    }, [CURRENT_PERIOD_COST_VS_TIME_COLUMN]: {
        title: t('columns.current_period_cost_vs_time.title'),
        subtitle: t('columns.current_period_cost_vs_time.subtitle'),
        helper: t('columns.current_period_cost_vs_time.helper'),
    }, [PLATFORM_BUDGET_COLUMN]: {
        title: t('columns.platform_budget.title'),
        subtitle: t('columns.platform_budget.subtitle'),
        helper: t('columns.platform_budget.helper'),
    }, [CAMPAIGN_STATUS_COLUMN]: {
        title: t('columns.campaign_status.title'),
        subtitle: '',
        helper: t('columns.campaign_status.helper'),
    }
});

export const PERIOD_TODAY = "TODAY";
export const PERIOD_YESTERDAY = "YESTERDAY";
export const PERIOD_THIS_WEEK = "THIS_WEEK";
export const PERIOD_LAST_WEEK = "LAST_WEEK";
export const PERIOD_LAST_7_DAYS = "LAST_7_DAYS";
export const PERIOD_LAST_14_DAYS = "LAST_14_DAYS";
export const PERIOD_LAST_30_DAYS = "LAST_30_DAYS";
export const PERIOD_THIS_MONTH = "THIS_MONTH";
export const PERIOD_THIS_MONTH_TILL_YESTERDAY = "THIS_MONTH_TILL_YESTERDAY";
export const PERIOD_LAST_MONTH = "LAST_MONTH";
export const PERIOD_LAST_3_MONTHS = "LAST_3_MONTHS";
export const PERIOD_LAST_6_MONTHS = "LAST_6_MONTHS";
export const PERIOD_THIS_PERIOD = "THIS_PERIOD";
export const PERIOD_THIS_PERIOD_TILL_YESTERDAY = "THIS_PERIOD_TILL_YESTERDAY";
export const PERIOD_7_DAYS_BEFORE = "7_DAYS_BEFORE";
export const PERIOD_14_DAYS_BEFORE = "14_DAYS_BEFORE";
export const PERIOD_PREVIOUS_PERIOD = "PREVIOUS_PERIOD";
export const PERIOD_LAST_YEAR = "LAST_YEAR";
export const PERIOD_SAME_PERIOD_LAST_YEAR = "SAME_PERIOD_LAST_YEAR";

export const getPeriodsData = (t) => ({
    [PERIOD_TODAY]: t('periods.today'),
    [PERIOD_YESTERDAY]: t('periods.yesterday'),
    [PERIOD_THIS_WEEK]: t('periods.this_week'),
    [PERIOD_LAST_WEEK]: t('periods.last_week'),
    [PERIOD_LAST_7_DAYS]: t('periods.last_7_days'),
    [PERIOD_LAST_14_DAYS]: t('periods.last_14_days'),
    [PERIOD_LAST_30_DAYS]: t('periods.last_30_days'),
    [PERIOD_THIS_MONTH]: t('periods.this_month'),
    [PERIOD_THIS_MONTH_TILL_YESTERDAY]: t('periods.this_month_till_yesterday'),
    [PERIOD_LAST_MONTH]: t('periods.last_month'),
    [PERIOD_THIS_PERIOD]: t('periods.this_period'),
    [PERIOD_THIS_PERIOD_TILL_YESTERDAY]: t('periods.this_period_till_yesterday'),
    [PERIOD_LAST_3_MONTHS]: t('periods.last_3_months'),
    [PERIOD_LAST_6_MONTHS]: t('periods.last_6_months'),
    [PERIOD_7_DAYS_BEFORE]: t('periods.7_days_before'),
    [PERIOD_14_DAYS_BEFORE]: t('periods.14_days_before'),
    [PERIOD_PREVIOUS_PERIOD]: t('periods.previous_period'),
    [PERIOD_LAST_YEAR]: t('periods.last_year'),
    [PERIOD_SAME_PERIOD_LAST_YEAR]: t('periods.same_period_last_year'),
});

// Keep the old export for backward compatibility
export const PERIODS_DATA = getPeriodsData;

// UI-3 followup: cache module-level de display_name de AgencyCustomMetric.
// Lo populates Dashboard.js cuando llega `basic-data` (single source — refresca
// en cada mount). Lo consumen `GET_COLUMN_DATA` y `getColumnData` cuando una
// columna FlexIndicator usa una métrica con prefijo `CUSTOM:` (id-namespaced).
let _CUSTOM_METRIC_LABELS_BY_KEY = {};

export function setCustomMetricLabelsCache(customMetricsList) {
    const map = {};
    (customMetricsList || []).forEach((cm) => {
        if (!cm) return;
        const key = cm.metric_key || (cm.id != null ? ('CUSTOM:' + cm.id) : null);
        if (!key) return;
        map[key] = cm.display_name || cm.name || key;
    });
    _CUSTOM_METRIC_LABELS_BY_KEY = map;
}

function _resolveCustomMetricLabel(metricName) {
    return _CUSTOM_METRIC_LABELS_BY_KEY[metricName] || metricName;
}

function _isCustomMetricKey(metricName) {
    return typeof metricName === 'string' && metricName.indexOf('CUSTOM:') === 0;
}

// Helper público: resuelve el display name de cualquier metric_name de forma defensiva.
// - CUSTOM:* → cache `_CUSTOM_METRIC_LABELS_BY_KEY` (hidratado por basic-data).
// - built-in en PROPERTIES_FOR_METRIC → su `Spanish`.
// - desconocida → el metric_name crudo.
// Usado por cell renderers / tooltips que antes asumían `PROPERTIES_FOR_METRIC[name]["Spanish"]`
// y crasheaban con CUSTOM:* (undefined.Spanish → TypeError → ErrorBoundary).
export function resolveMetricDisplayName(metricName) {
    if (_isCustomMetricKey(metricName)) {
        return _resolveCustomMetricLabel(metricName);
    }
    const props = PROPERTIES_FOR_METRIC[metricName];
    return (props && props["Spanish"]) || metricName;
}

// UI-4 followup: los 4 períodos canónicos para los indicators auto-derivados
// de cada AgencyCustomMetric. Coincide con `CUSTOM_METRIC_AUTO_PERIODS` del backend
// (`flex_indicators_manager.py`). Mantener sincronizado.
export const CUSTOM_METRIC_AUTO_PERIODS = ['TODAY', 'THIS_PERIOD', 'THIS_MONTH', 'LAST_MONTH'];

// Helper público: genera los FlexIndicator strings auto-derivados de cada
// AgencyCustomMetric activa × 4 períodos. Format: `FLEX_INDICATOR||CUSTOM:<id>||<period>||NO_COMPARATION`.
// Cliente computa para no depender de un campo nuevo del backend — la lista
// `customMetrics` ya viene en basic-data (Fase 3). Dedupea contra los flex
// indicators manuales para evitar duplicados en el column picker.
export function buildAutoCustomMetricIndicators(customMetrics, manualFlexIndicators) {
    if (!Array.isArray(customMetrics) || customMetrics.length === 0) return [];
    const manual = new Set(manualFlexIndicators || []);
    const result = [];
    customMetrics.forEach((cm) => {
        if (!cm || cm.id == null) return;
        if (cm.has_broken_reference) return;  // métricas rotas no se ofrecen como columnas
        const key = 'CUSTOM:' + cm.id;
        CUSTOM_METRIC_AUTO_PERIODS.forEach((period) => {
            const indicator = AGENCY_FLEX_INDICATOR + '||' + key + '||' + period + '||NO_COMPARATION';
            if (manual.has(indicator)) return;
            result.push(indicator);
        });
    });
    return result;
}

// f"{FLEX_INDICATOR}||{metric_name}||{main_period}||{vs_period}"
export const FLEX_INDICATOR_COLUMN_TO_DATA = ((columnId) => {
    if(!columnId.includes(AGENCY_FLEX_INDICATOR)) {
        return null;
    }

    const parts =  columnId.split('||');
    const metricName = parts[1];
    const mainPeriod = parts[2];
    const vsPeriod = parts[3];

    return {
        'metricName': metricName,
        'mainPeriod': mainPeriod,
        'vsPeriod': vsPeriod
    }
});

export const NO_COMPARATION_PERIOD = "NO_COMPARATION";

export const GET_COLUMN_DATA = ((columnId) => {
    if(columnId.includes(AGENCY_FLEX_INDICATOR)) {
        const columnRawData = FLEX_INDICATOR_COLUMN_TO_DATA(columnId);
        const metricName = columnRawData && columnRawData["metricName"];
        let helper;
        if(columnId.includes("GA4")) {
            helper = "Para mostrar información de GA4 debe asociar una cuenta de GA4 en la cuenta del presupuesto";
        } else if(metricName && metricName.includes("Ecommerce")) {
            helper = "Para mostrar información de Ecommerce debe asociar una tienda de Ecommerce en la cuenta del presupuesto";
        } else if (_isCustomMetricKey(metricName)) {
            helper = 'Métrica personalizada de la agencia. Definí la fórmula en Personalización → Métricas personalizadas.';
        } else {
            helper = 'Éste indicador es personalizado. Se puede modificar en la configuración de la agencia. Sobre una métrica dada, muestra el valor de un período y lo compara contra otro.';
        }

        // Para CUSTOM:* leemos del cache de display_names hidratado por basic-data.
        // Fallback al raw `CUSTOM:<id>` si todavía no hidrataron (transient).
        const title = _isCustomMetricKey(metricName)
            ? _resolveCustomMetricLabel(metricName)
            : (PROPERTIES_FOR_METRIC[metricName] ? PROPERTIES_FOR_METRIC[metricName]["Spanish"] : metricName);

        return {
            'title': title,
            'subtitle': PERIODS_TO_TEXT(columnRawData["mainPeriod"], columnRawData["vsPeriod"]),
            'helper': helper
        };
    }

    return COLUMN_HEADER_INFORMATION[columnId];
});

// Mapa metricName -> key i18n del label. Module-level y única fuente: tanto el label
// (getMetricName) como la descripción/tooltip (getMetricHelper, key `<labelKey>.helper`)
// se derivan de acá. Cubre TODAS las plataformas (Meta/Google/TikTok/GA4/Ecommerce):
// para habilitar el tooltip de cualquier métrica basta con agregar `<labelKey>.helper`
// en languajes/{es,en}.json — sin tocar este archivo.
export const METRIC_LABEL_KEY_BY_NAME = {
        [COST_METRIC_NAME]: 'metrics.cost',
        [CLICKS_METRIC_NAME]: 'metrics.clicks',
        [CONVERSIONS_METRIC_NAME]: 'metrics.conversions',
        [IMPRESSIONS_METRIC_NAME]: 'metrics.impressions',
        [CPC_METRIC_NAME]: 'metrics.cpc',
        [CTR_METRIC_NAME]: 'metrics.ctr',
        [CPM_METRIC_NAME]: 'metrics.cpm',
        [CPA_METRIC_NAME]: 'metrics.cpa',
        [PURCHASES_VALUE_METRIC_NAME]: 'metrics.purchase_value',
        [ROAS_METRIC_NAME]: 'metrics.roas',
        [ACOS_METRIC_NAME]: 'metrics.acos',
        [CONVERSION_RATE_METRIC_NAME]: 'metrics.conversion_rate',
        [GA4_SESSIONS_METRIC_NAME]: 'metrics.ga4_sessions',
        [GA4_ACTIVE_USERS_METRIC_NAME]: 'metrics.ga4_active_users',
        [GA4_CONVERSIONS_METRIC_NAME]: 'metrics.ga4_conversions',
        [GA4_ECOMMERCE_PURCHASES_METRIC_NAME]: 'metrics.ga4_ecommerce_purchases',
        [GA4_PURCHASE_REVENUE_METRIC_NAME]: 'metrics.ga4_purchase_revenue',
        [GA4_ROAS_METRIC_NAME]: 'metrics.ga4_roas',
        [GA4_ACOS_METRIC_NAME]: 'metrics.ga4_acos',
        [GA4_CPA_METRIC_NAME]: 'metrics.ga4_cpa',
        [ECOMMERCE_SESSIONS_METRIC_NAME]: 'metrics.ecommerce_sessions',
        [ECOMMERCE_GROSS_REVENUE_METRIC_NAME]: 'metrics.ecommerce_gross_revenue',
        [ECOMMERCE_ORDERS_METRIC_NAME]: 'metrics.ecommerce_orders',
        [ECOMMERCE_AVG_GROSS_ORDER_VALUE_METRIC_NAME]: 'metrics.ecommerce_avg_gross_order_value',
        [ECOMMERCE_ROAS_METRIC_NAME]: 'metrics.ecommerce_roas',
        [ECOMMERCE_ACOS_METRIC_NAME]: 'metrics.ecommerce_acos',
        [ECOMMERCE_CONVERTION_RATE_METRIC_NAME]: 'metrics.ecommerce_conversion_rate',
        [ECOMMERCE_CPA_METRIC_NAME]: 'metrics.ecommerce_cpa',
        [META_REACH_METRIC_NAME]: 'metrics.meta_reach',
        [META_FREQUENCY_METRIC_NAME]: 'metrics.meta_frequency',
        [META_VIDEO_VIEW_METRIC_NAME]: 'metrics.meta_video_view',
        [META_THRUPLAY_METRIC_NAME]: 'metrics.meta_thruplay',
        [META_COST_PER_THRUPLAY_METRIC_NAME]: 'metrics.meta_cost_per_thruplay',
        [META_VIDEO_VIEW_3S_METRIC_NAME]: 'metrics.meta_video_view_3s',
        [META_VIDEO_VIEW_3S_RATE_METRIC_NAME]: 'metrics.meta_video_view_3s_rate',
        [META_IG_NEW_FOLLOWERS_METRIC_NAME]: 'metrics.meta_ig_new_followers',
        [META_COST_PER_IG_NEW_FOLLOWER_METRIC_NAME]: 'metrics.meta_cost_per_ig_new_follower',
        [META_IG_PROFILE_VISITS_METRIC_NAME]: 'metrics.meta_ig_profile_visits',
        [META_COST_PER_IG_PROFILE_VISIT_METRIC_NAME]: 'metrics.meta_cost_per_ig_profile_visit',
        [META_POST_REACTION_METRIC_NAME]: 'metrics.meta_post_reaction',
        [META_COMMENT_METRIC_NAME]: 'metrics.meta_comment',
        [META_CLICK_TO_CALL_METRIC_NAME]: 'metrics.meta_click_to_call',
        [META_LIKE_METRIC_NAME]: 'metrics.meta_like',
        [META_COST_PER_LIKE_METRIC_NAME]: 'metrics.meta_cost_per_like',
        [META_PIXEL_PURCHASE_METRIC_NAME]: 'metrics.meta_pixel_purchase',
        [META_COST_PER_PIXEL_PURCHASE_METRIC_NAME]: 'metrics.meta_cost_per_pixel_purchase',
        [META_PIXEL_LEAD_METRIC_NAME]: 'metrics.meta_pixel_lead',
        [META_COST_PER_PIXEL_LEAD_METRIC_NAME]: 'metrics.meta_cost_per_pixel_lead',
        [META_MESSAGING_CONVERSATION_STARTED_7D_METRIC_NAME]: 'metrics.meta_messaging_conversation_started_7d',
        [META_COST_PER_MESSAGING_CONVERSATION_STARTED_7D_METRIC_NAME]: 'metrics.meta_cost_per_messaging_conversation_started_7d',
        [META_LEAD_METRIC_NAME]: 'metrics.meta_lead',
        [META_COST_PER_LEAD_METRIC_NAME]: 'metrics.meta_cost_per_lead',
        [META_ONSITE_LEAD_METRIC_NAME]: 'metrics.meta_onsite_lead',
        [META_COST_PER_ONSITE_LEAD_METRIC_NAME]: 'metrics.meta_cost_per_onsite_lead',
        [GOOGLE_SEARCH_IS_METRIC_NAME]: 'metrics.google_search_is',
        [GOOGLE_SEARCH_TOP_IS_METRIC_NAME]: 'metrics.google_search_top_is',
        [GOOGLE_SEARCH_ABS_TOP_IS_METRIC_NAME]: 'metrics.google_search_abs_top_is',
        [GOOGLE_SEARCH_LOST_IS_RANK_METRIC_NAME]: 'metrics.google_search_lost_is_rank',
        [GOOGLE_SEARCH_LOST_IS_BUDGET_METRIC_NAME]: 'metrics.google_search_lost_is_budget',
        [GOOGLE_VIDEO_QUARTILE_P25_RATE_METRIC_NAME]: 'metrics.google_video_quartile_p25_rate',
        [GOOGLE_VIDEO_VIEWS_METRIC_NAME]: 'metrics.google_video_views',
        [GOOGLE_CPV_METRIC_NAME]: 'metrics.google_cpv',
        [GOOGLE_INTERACTIONS_METRIC_NAME]: 'metrics.google_interactions',
        [TIKTOK_REACH_METRIC_NAME]: 'metrics.tiktok_reach',
        [TIKTOK_FREQUENCY_METRIC_NAME]: 'metrics.tiktok_frequency',
        [TIKTOK_VIDEO_VIEWS_METRIC_NAME]: 'metrics.tiktok_video_views',
        [TIKTOK_VIDEO_VIEW_2S_METRIC_NAME]: 'metrics.tiktok_video_view_2s',
        [TIKTOK_VIDEO_VIEW_2S_RATE_METRIC_NAME]: 'metrics.tiktok_video_view_2s_rate',
        [TIKTOK_FOLLOWS_METRIC_NAME]: 'metrics.tiktok_follows',
        [TIKTOK_COST_PER_FOLLOW_METRIC_NAME]: 'metrics.tiktok_cost_per_follow',
        [TIKTOK_PROFILE_VISITS_METRIC_NAME]: 'metrics.tiktok_profile_visits',
        [TIKTOK_COST_PER_PROFILE_VISIT_METRIC_NAME]: 'metrics.tiktok_cost_per_profile_visit',
        [TIKTOK_LIKES_METRIC_NAME]: 'metrics.tiktok_likes',
        [TIKTOK_COMMENTS_METRIC_NAME]: 'metrics.tiktok_comments',
        [TIKTOK_VIDEO_VIEW_6S_METRIC_NAME]: 'metrics.tiktok_video_view_6s',
        [TIKTOK_VIDEO_VIEW_6S_RATE_METRIC_NAME]: 'metrics.tiktok_video_view_6s_rate',
        [LINKEDIN_VIDEO_VIEWS_METRIC_NAME]: 'metrics.linkedin_video_views',
        [LINKEDIN_VIDEO_COMPLETIONS_METRIC_NAME]: 'metrics.linkedin_video_completions',
        [LINKEDIN_TOTAL_ENGAGEMENTS_METRIC_NAME]: 'metrics.linkedin_total_engagements',
        [LINKEDIN_REACTIONS_METRIC_NAME]: 'metrics.linkedin_reactions',
        [LINKEDIN_COMMENTS_METRIC_NAME]: 'metrics.linkedin_comments',
        [LINKEDIN_SHARES_METRIC_NAME]: 'metrics.linkedin_shares',
        [LINKEDIN_FOLLOWS_METRIC_NAME]: 'metrics.linkedin_follows',
        [LINKEDIN_LEAD_FORM_LEADS_METRIC_NAME]: 'metrics.linkedin_lead_form_leads',
        [LINKEDIN_LEAD_FORM_OPENS_METRIC_NAME]: 'metrics.linkedin_lead_form_opens'
};

export const getMetricName = (t, metricName) => {
    // CUSTOM:<id> (AgencyCustomMetric) no tiene key i18n: se resuelve contra el cache de
    // display_names. La pantalla que lo muestre debe hidratarlo (fetchCustomMetrics +
    // setCustomMetricLabelsCache) — si no, cae al raw "CUSTOM:6".
    if (_isCustomMetricKey(metricName)) {
        return _resolveCustomMetricLabel(metricName);
    }
    const translationKey = METRIC_LABEL_KEY_BY_NAME[metricName];
    return translationKey ? t(translationKey) : metricName;
};

// Descripción/tooltip de una métrica para el ⓘ del modal "Configuración de columnas" y
// el hover del header del tablero (ambos vía getColumnData). Convención: la key del
// label + sufijo `.helper`. Devuelve '' si la métrica no tiene descripción definida, y
// el caller cae al helper genérico de flex indicator. Soporta es/en por i18n y sirve a
// cualquier plataforma sin tocar código (solo sumar `<labelKey>.helper` a los json).
export const getMetricHelper = (t, metricName) => {
    const labelKey = METRIC_LABEL_KEY_BY_NAME[metricName];
    if (!labelKey) return '';
    const helperKey = `${labelKey}.helper`;
    return i18n.exists(helperKey) ? t(helperKey) : '';
};

export const getColumnData = (t, columnId) => {
    if(columnId.includes(AGENCY_FLEX_INDICATOR)) {
        const columnRawData = FLEX_INDICATOR_COLUMN_TO_DATA(columnId);
        const metricName = columnRawData && columnRawData["metricName"];
        let helper;
        if(columnId.includes("GA4")) {
            helper = t('columns.flex_indicator_ga4.helper');
        } else if(columnId.toLowerCase().includes("ecommerce")) {
            helper = t('columns.flex_indicator_ecommerce.helper');
        } else if (_isCustomMetricKey(metricName)) {
            helper = t('columns.flex_indicator_custom.helper',
                'Métrica personalizada de la agencia. Definí la fórmula en Personalización → Métricas personalizadas.');
        } else {
            helper = getMetricHelper(t, metricName) || t('columns.flex_indicator.helper');
        }

        // CUSTOM:* resuelve contra el cache hidratado por basic-data (Dashboard.js).
        // Fallback al raw key si todavía no hidrataron (transient en cold-start).
        const title = _isCustomMetricKey(metricName)
            ? _resolveCustomMetricLabel(metricName)
            : getMetricName(t, metricName);

        return {
            'title': title,
            'subtitle': getPeriodsToText(t, columnRawData["mainPeriod"], columnRawData["vsPeriod"]),
            'helper': helper
        };
    }

    // AgencyCustomMetric columns: pattern CUSTOM_METRIC||<name>||<period>||<comparison>
    // El name del custom metric viene del backend ya slugificado (sin `|`), pero defendemos
    // contra un legacy/dirty value para evitar romper el dashboard si se cuela basura.
    if (columnId && columnId.indexOf('CUSTOM_METRIC||') === 0) {
        const parts = columnId.split('||');
        if (parts.length === 4 && parts[1] && !parts[1].includes('|')) {
            return {
                'title': parts[1],   // name del custom; display_name lo resuelve el renderer dedicado con metadata del basic-data
                'subtitle': getPeriodsToText(t, parts[2], parts[3] === 'NO_COMPARATION' ? null : parts[3]),
                'helper': t('columns.custom_metric.helper', 'Métrica personalizada de la agencia. Definí la fórmula en /agency/custom-metrics.'),
            };
        }
    }

    return getColumnHeaderInformation(t)[columnId];
};

export const PERIODS_TO_TEXT = ((mainPeriod, vsPeriod) => {
    // This function is deprecated - use getPeriodsToText(t, mainPeriod, vsPeriod) instead
    // Keeping for backward compatibility but it will return untranslated text
    const fallbackData = {
        [PERIOD_TODAY]: "Hoy",
        [PERIOD_YESTERDAY]: "Ayer",
        [PERIOD_THIS_WEEK]: "Esta semana (L a D)",
        [PERIOD_LAST_WEEK]: "Semana pasada (L a D)",
        [PERIOD_LAST_7_DAYS]: "Últimos 7 días",
        [PERIOD_LAST_14_DAYS]: "Últimos 14 días",
        [PERIOD_LAST_30_DAYS]: "Últimos 30 días",
        [PERIOD_THIS_MONTH]: "Este mes",
        [PERIOD_THIS_MONTH_TILL_YESTERDAY]: "Este mes (hasta ayer)",
        [PERIOD_LAST_MONTH]: "Mes anterior",
        [PERIOD_THIS_PERIOD]: "Este período",
        [PERIOD_THIS_PERIOD_TILL_YESTERDAY]: "Este período (hasta ayer)",
        [PERIOD_LAST_3_MONTHS]: 'Últimos 3 meses',
        [PERIOD_LAST_6_MONTHS]: 'Últimos 6 meses',
        [PERIOD_7_DAYS_BEFORE]: '7 días anteriores',
        [PERIOD_14_DAYS_BEFORE]: '14 días anteriores',
        [PERIOD_PREVIOUS_PERIOD]: 'Período anterior',
        [PERIOD_LAST_YEAR]: 'Año anterior',
        [PERIOD_SAME_PERIOD_LAST_YEAR]: 'Mismo período del año anterior',
    };
    
    if(vsPeriod !== NO_COMPARATION_PERIOD)
        return fallbackData[mainPeriod]+" vs "+fallbackData[vsPeriod];
    return fallbackData[mainPeriod];
});

export const getPeriodsToText = (t, mainPeriod, vsPeriod) => {
    const periodsData = getPeriodsData(t);
    if(vsPeriod !== NO_COMPARATION_PERIOD)
        return periodsData[mainPeriod]+" vs "+periodsData[vsPeriod];
    return periodsData[mainPeriod];
};

export const INDICATORS_COLUMNS = TODAY_COLUMNS.concat(FULL_PERIOD_COLUMNS).concat([DAYS_TILL_FUNDS_ARE_OUT_COLUMN]);
export const CONFIGURABLE_COLUMN_NAMES = [LABELS_COLUMN, CURRENCY_COLUMN, CURRENT_PERIOD_TIME_COMPLETION_COLUMN, COMMENTS_COLUMN].concat(INDICATORS_COLUMNS).concat(AVAILABLE_FUNDS_COLUMNS);

export const COLUMN_CELL_INVALID_CONTENT = "---";
export const COLUMN_STATUS_PROCESSING = "PROCESSING";


export const COLUMNS_SET_KPIS = 'Control Rápido (KPIs)';
export const DEFAULT_COLUMN_SET = COLUMNS_SET_KPIS;

export const getColumnsSetKpis = (t) => t('columns.kpi_control_set');
export const getDefaultColumnSet = (t) => getColumnsSetKpis(t);